export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-100">
      <div className="flex flex-col items-center gap-6">
        <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-2xl font-semibold shadow-lg">
          F
        </div>
        <div className="text-center">
          <h1 className="text-xl font-semibold tracking-tight">
            loyflowmanager
          </h1>
          <p className="mt-2 text-sm text-slate-400">Conectando ao Keycloak…</p>
        </div>
        <div
          className="h-1.5 w-40 overflow-hidden rounded-full bg-slate-800"
          aria-hidden="true"
        >
          <div className="h-full w-1/3 animate-pulse rounded-full bg-blue-500" />
        </div>
      </div>
    </div>
  );
}
